<template>
    <div class="page wrong-book-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>错题本</el-breadcrumb-item>
            </el-breadcrumb>
            <!-- <div class="page-title">
                <div class="title-icon">
                    <i class="el-icon-notebook-2"></i>
                </div>
                <div class="title-text">
                    <h2>错题本</h2>
                    <p>记录错题，巩固知识，提升成绩</p>
                </div>
            </div> -->
        </div>

        <!-- 筛选区域 -->
        <div class="filter-section">
            <mainSelect :showPopup="1"
                        :selectPaperNameByHome="questionName"
                        @reset-select="resetWrongBookList"
                        @new-select-submit-date="selectBySubmitDateAndWrong"
                        @new-select-question-type="selectByQuestionTypeAndWrong"
                        @send-selected-to-parent="getTestPaperBySelectAndWrong"
                        @new-select-context="selectWrongByQuestionTitle">
            </mainSelect>
        </div>

        <!-- 内容区域 -->
        <div class="content-section" v-loading="loading">
            <!-- 空状态 -->
            <div v-if="worngBook.length === 0" class="empty-state">
                <div class="empty-icon">
                    <i class="el-icon-trophy"></i>
                </div>
                <div class="empty-text">
                    <h3>太棒了，完全正确无误！</h3>
                    <p>继续保持，你是最棒的！</p>
                </div>
            </div>
            <!-- 错题列表 -->
            <div v-else class="wrong-list">
                <div class="list-header">
                    <span class="list-count">
                        <i class="el-icon-document"></i>
                        共 <strong>{{ allInfo.total }}</strong> 道错题
                    </span>
                </div>
                <div v-for="(item,index) in worngBook" :key="item.id" class="wrong-item">
                    <wrongBookDetails :worngBookDetails="item" :subjectId="index + 1"></wrongBookDetails>
                </div>
            </div>

            <!-- 分页器 -->
            <el-pagination 
                v-if="worngBook.length > 0"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange"
                :current-page="currentPage" 
                :page-sizes="[5, 10, 20, 30, 50]" 
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" 
                :total="allInfo.total"
                class="custom-pagination">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import mainSelect from "@/components/mainSelect.vue"
    import wrongBookDetails from "./components/wrongBookDetails.vue"
    import {
        wrongBookList
    } from "@/api/index.js"

    export default {
        components: {
            mainSelect,
            wrongBookDetails
        },
        data() {
            return {
                loading: false,
                worngBook: [],
                allInfo: {
                    total: 0
                },
                nowType: {},
                currentPage: 1,
                pageSize: 5,
                haveMore: false,
                noMore: false,
                isLoading: true,
                questionName: '',
                matchParent: 'ALL',
                langParent: 'ALL',
                levelParent: 'ALL',
                createTime: null,
                questionType: null
            };
        },
        watch: {
            questionName: {
                handler: function (n, o) {
                    if (n !== undefined) {
                        this.selectWrongBookList();
                    }
                }
            },

        },
        methods: {

            resetData() {
                this.loading = false;
                this.worngBook = [];
                this.allInfo = {
                    total: 0
                };
                this.currentPage = 1;
                this.pageSize = 5;
                this.haveMore = false;
                this.noMore = false;
                this.isLoading = true;
                this.matchParent = 'ALL';
                this.langParent = 'ALL';
                this.levelParent = 'ALL';
                this.createTime = null;
                this.questionType = null;
                this.questionName = "";
                this.questionType = null;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.currentPage = 1;
                this.selectWrongBookList()
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.selectWrongBookList()
            },
            resetWrongBookList() {
                this.questionName = "";
                this.resetData();
                this.selectWrongBookList();
            },
            selectBySubmitDateAndWrong(val) {
                this.createTime = val;
                this.selectWrongBookList();
            },
            selectByQuestionTypeAndWrong(val) {
                this.questionType = val;
                this.selectWrongBookList();
            },
            getTestPaperBySelectAndWrong(data) {
                this.matchParent = data.selectedMatch;
                this.langParent = data.selectedLang;
                this.levelParent = data.selectedLevel;

                this.selectWrongBookList();
            },
            selectWrongByQuestionTitle(val){
                this.questionName = val
            },
            selectWrongBookList() {
                this.loading = true;
                let param = {
                    currentPage: this.currentPage,
                    pageSize: this.pageSize,
                    match: this.matchParent,
                    lang: this.langParent,
                    level: this.levelParent,
                    questionName: this.questionName,
                    questionType: this.questionType,
                    createTime: this.createTime
                }
                wrongBookList(param).then(res => {
                    if (res.code === "0000") {
                        this.allInfo = res.data;
                        this.worngBook = res.data.list;
                        this.loading = false;
                        this.scrollToTop();
                    }
                }).catch(() => {
                    this.loading = false;
                    // this.$router.push({
                    // 	path: '/'
                    // })
                });
            },
            scrollToTop() {
                // 使用 window.scrollTo 方法将页面滚动到顶部
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // 平滑滚动效果
                });
            }
        },
        mounted() {
            this.selectWrongBookList();
            // this.getInfo()
            // let _this = this;
            // window.onscroll = function() {
            // 	//变量scrollTop是滚动条滚动时，距离顶部的距离
            // 	var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            // 	//变量windowHeight是可视区的高度
            // 	var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            // 	//变量scrollHeight是滚动条的总高度
            // 	var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            // 	//滚动条到底部的条件
            // 	if (scrollTop + windowHeight == scrollHeight) {
            // 		//到了这个就可以进行业务逻辑加载后台数据了
            // 		// _this.footerText = '我是有底线的';
            // 		if (_this.allInfo.total > _this.worngBook.length) {
            // 			if (_this.isLoading) {
            // 				_this.isLoading = false
            // 				_this.haveMore = true
            // 				_this.currentPage = _this.currentPage + 1
            // 				setTimeout(() => {
            // 					console.log("2")
            // 					_this.getInfo()
            // 				}, 1000);
            // 				console.log(_this.worngBook)
            // 				console.log("到了底部");
            // 			}
            // 		} else {
            // 			_this.haveMore = false
            // 			_this.noMore = true
            // 		}
            // 	}
            // }
        }
    };
</script>

<style lang="scss" scoped>
/* 页面容器 */
.wrong-book-page {
    min-height: 64.5vh;
    padding-bottom: 40px;
}

/* 页面头部 */
.page-header {
    margin-bottom: 20px;
}

.page-breadcrumb {
    margin: 15px 0;
    padding: 10px 16px;
    background: #fafafa;
    border-radius: 4px;
    cursor: pointer;
}

.page-title {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 24px;
    background: linear-gradient(135deg, #409EFF 0%, #66B1FF 100%);
    border-radius: 8px;
    color: #ffffff;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);

    .title-icon {
        width: 56px;
        height: 56px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
            font-size: 28px;
            color: #ffffff;
        }
    }

    .title-text {
        h2 {
            margin: 0 0 6px 0;
            font-size: 22px;
            font-weight: 600;
        }

        p {
            margin: 0;
            font-size: 14px;
            opacity: 0.9;
        }
    }
}

/* 筛选区域 */
.filter-section {
    margin-bottom: 20px;
}

/* 内容区域 */
.content-section {
    min-height: 400px;
}

/* 空状态 */
.empty-state {
    background: #ffffff;
    border-radius: 8px;
    padding: 80px 40px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    .empty-icon {
        width: 100px;
        height: 100px;
        margin: 0 auto 24px;
        background: linear-gradient(135deg, #67C23A 0%, #95D475 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 8px 24px rgba(103, 194, 58, 0.3);

        i {
            font-size: 48px;
            color: #ffffff;
        }
    }

    .empty-text {
        h3 {
            margin: 0 0 8px 0;
            font-size: 20px;
            color: #333;
            font-weight: 600;
        }

        p {
            margin: 0;
            font-size: 14px;
            color: #909399;
        }
    }
}

/* 错题列表 */
.wrong-list {
    .list-header {
        margin-bottom: 16px;
        padding: 12px 16px;
        background: #f5f7fa;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .list-count {
            font-size: 14px;
            color: #606266;
            display: flex;
            align-items: center;
            gap: 6px;

            i {
                color: #409EFF;
            }

            strong {
                color: #409EFF;
                font-size: 16px;
            }
        }
    }

    .wrong-item {
        margin-bottom: 0;
    }
}

/* 分页器优化 */
.custom-pagination {
    margin-top: 24px;
    text-align: center;
    padding: 20px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    ::v-deep .el-pagination__total {
        color: #909399;
    }

    ::v-deep .el-pager li {
        border-radius: 4px;
        margin: 0 3px;
        transition: all 0.2s ease;

        &:hover {
            background: #E7F3FF;
            color: #409EFF;
        }

        &.active {
            background: linear-gradient(135deg, #409EFF 0%, #66B1FF 100%);
            color: #ffffff;
        }
    }

    ::v-deep .btn-prev,
    ::v-deep .btn-next {
        border-radius: 4px;
        transition: all 0.2s ease;

        &:hover {
            background: #E7F3FF;
            color: #409EFF;
        }
    }
}

/* 加载动画优化 */
::v-deep .el-loading-mask {
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.9);

    .el-loading-spinner {
        .path {
            stroke: #409EFF;
        }

        .el-loading-text {
            color: #409EFF;
        }
    }
}

</style>
